module.exports = __webpack_public_path__ + "img/claimHead.2450c46c.jpg";